import React, { useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRoute from "./components/AdminRoute";
import NotFound from "./pages/NotFound";
import { publicRoutes, protectedRoutes, adminRoutes } from "./routes/routes";
import { ROUTES } from "./config/constants";

// === Layout Header ===
function LayoutHeader({ children }) {
  const location = useLocation();
  const [setSidebarOpen] = useState(true);

  const hideNavPaths = [ROUTES.HOME, ROUTES.LOGIN, ROUTES.PUBLIC_PORTAL, "/register", "/digitalizationmanagement", "/engineeringtools", "/"];
  const shouldHideNav = hideNavPaths.some((path) =>
    location.pathname === path,
  );

  

  const toggleSidebar = () => {
    if (window.innerWidth <= 768) {
      setSidebarOpen((prev) => !prev);
    }
  };

  return (
    <>
      {!shouldHideNav && <Header toggleSidebar={toggleSidebar} />}
      {children}
    </>
  );
}

// === Layout Footer ===
function LayoutFooter() {
  const location = useLocation();
  const hideFooterPaths = [ROUTES.LOGIN];
  const isDashboardFooter = location.pathname.startsWith("/dashboard");
  const shouldHideFooter = isDashboardFooter || hideFooterPaths.some((path) =>
    location.pathname.startsWith(path),
  );

  return !shouldHideFooter ? <Footer /> : null;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster />
      <div className="flex flex-col min-h-screen bg-gray-50">
        <LayoutHeader>
          <main className="flex-grow w-full mt-0">
            <Routes>
              {/* PUBLIC ROUTES */}
              {publicRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<route.element />}
                />
              ))}

              {/* PROTECTED ROUTES (All authenticated users) */}
              {protectedRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <ProtectedRoute>
                      <route.element />
                    </ProtectedRoute>
                  }
                />
              ))}

              {/* ADMIN-ONLY ROUTES */}
              {adminRoutes.map((route) => (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <ProtectedRoute>
                      <AdminRoute>
                        <route.element />
                      </AdminRoute>
                    </ProtectedRoute>
                  }
                />
              ))}

              {/* 404 NOT FOUND - Catch all unmatched routes */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </LayoutHeader>

        <LayoutFooter />
      </div>
    </BrowserRouter>
  );
}
